import { TemplateData, TemplateParams } from '.';

const achievementSupervisorAddedToConversationNotes = ({
  defaultPlaceholders,
  messages,
  serverConfig
}: TemplateParams): TemplateData => ({
  category: 'achievements',
  email: {
    buttonEnabled: true,
    buttonLink: '{{achievementSupervisorUrl}}',
    buttonText: messages.authSignIn,
    content: `
      <p>
        ${messages.achievementSupervisorAddedToConversationNotesMessage}
        ${messages.achievementSupervisorAddedDescription}
      </p>`,
    contentAfterButton: `
      <p>
        ${messages.emailSignatureText}
      </p>`,
    footnote: `${messages.emailContentClarification} {{contactEmail}}`,
    heading: messages.emailGreeting,
    subject: `{{siteName}}: ${messages.achievementSupervisorAddedToConversationNotes}`
  },
  placeholders: {
    achievementSupervisorUrl: {
      label: messages.achievementSupervisorLink,
      example: `${serverConfig.adminUrl}/admin/achievements/1/my-team`
    },
    achievementTitle: {
      label: messages.achievementTitle,
      example: 'Test achievement'
    },
    ...defaultPlaceholders
  },
  title: messages.achievementSupervisorAddedToConversationNotes
});

export default achievementSupervisorAddedToConversationNotes;
